<template>
  <div class="contentssss">
    <div class="scores">
      <span>审核扣分</span>
      <input
        type="number"
        @input="handleScoreInput($event)"
        v-model="score"
        :placeholder="placeholder"
      />
    </div>
    <div class="memoe">
      <span>扣分原因</span>
      <div class="memoediv">
        <textarea v-model="memovalue" maxlength="500" placeholder="请输入扣分原因"></textarea>
      </div>
      <div class="tips">
        <span class="mspan">{{ memovaluechange }}</span>/500
      </div>
    </div>
    <div class="btndiv">
      <cusBtn2 value="提交" @click="onclicksub"></cusBtn2>
    </div>
    <uploadModal
      :isShow="isShow"
      title="是否提交审核"
      content="请确认该州(市)数据及扣分准确无误"
      okBtn="提交"
      @cancel="cancelModal"
      @onOk="commitScore"
      cancelBtn="取消"
    ></uploadModal>
    <tipTops :content="content" @closeModal="closeModal" :isShow="isShowsTip"></tipTops>
  </div>
</template>
<script>
import cusBtn2 from "./components/cusBtn2";
import uploadModal from "./components/uploadModal";
import API from "../../../service/index";
import tipTops from "../travelNegative/components/tipDialog";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
export default {
  name: "deductionAuditing",
  components: {
    cusBtn2,
    uploadModal,
    tipTops,
  },
  data() {
    return {
      memovalue: "",
      score: "",
      isShow: false,
      isShowsTip: false,
      id: this.$route.query.id,
      monitorType: this.$route.query.monitorType,
      placeholder:
        this.$route.query.monitorType === "A2"
          ? "请输扣分分数(≤2)"
          : "请输扣分分数(≤3)",
      content:
        this.$route.query.monitorType === "A2" ? "扣分需≤2分" : "扣分需≤3分",
    };
  },

  computed: {
    memovaluechange() {
      return this.memovalue.length;
    },
  },
  methods: {
    closeModal() {
      this.isShowsTip = false;
    },
    onclicksub() {
      if (Number(this.score) == NaN || !this.score) {
        this.$toast("请输入扣分分数");
        return false;
      }
      if (!this.memovalue) {
        this.$toast("请输入扣分原因");
        return false;
      }
      this.isShow = true;
    },
    handleScoreInput(event) {
      const newValue = (event.currentTarget || event.target).value;
      if (this.monitorType === "A2") {
        if (Number(newValue) > 2) {
          this.score = "";
          this.isShowsTip = true;
          return false;
        }
      } else {
        if (Number(newValue) > 3) {
          this.score = "";
          this.isShowsTip = true;
          return false;
        }
      }

      let a = newValue
        .replace(/[^\d.]/g, "")
        .replace(/\.{2,}/g, ".")
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
        .replace(/^\./g, "");
      this.score = a;
    },
    async commitScore() {
      this.isShow = false;
      const res = await API.authing({
        id: this.id,
        monitorType: this.monitorType,
        deduction: Number(this.score) * 100,
        deductionReason: this.memovalue,
      });
      if (res.ret === 0) {
        this.$Toast({
          message: "保存成功",
          icon,
        });
        setTimeout(() => {
          this.$router.back(-1);
        }, 1000);
      }
    },
    cancelModal() {
      this.isShow = false;
    },
  },
};
</script>
<style lang="less" scoped>
.contentssss {
  padding: 0 12px;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  .scores {
    height: 46px;
    width: 100%;
    line-height: 46px;
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    input {
      outline: none;
      border: none;
      margin-left: 24px;
      font-size: 14px;
    }
    input::-webkit-input-placeholder {
      color: #cccccc;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
    input:-ms-input-placeholder {
      color: #cccccc;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
    input::-webkit-inner-spin-button {
      color: #cccccc;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
  .scores::after {
    content: "";
    height: 1px;
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #e5e5e5;
    margin: 0 auto;
    padding: 0;
    overflow: hidden;
    transform: scaleY(0.5);
  }
  .memoe {
    position: relative;
    overflow: hidden;
    padding: 2px 0 0 0;
    margin-top: -2px;
    width: 100%;
    span {
      display: block;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    .memoediv {
      width: 100%;
      height: 180px;
      background: rgba(245, 245, 245, 1);
      border-radius: 3px;
      padding: 15px 12px 28px 12px;
      margin-top: 12px;
      textarea {
        outline: none;
        border: none;
        resize: none;
        width: 100%;
        height: 100%;
        font-size: 14px;
        line-height: 20px;
        padding: 1px 0;
        background: rgba(245, 245, 245, 1);
      }

      textarea::-webkit-input-placeholder {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(204, 204, 204, 1);
      }
      textarea:-moz-placeholder {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(204, 204, 204, 1);
      }
      textarea:-ms-input-placeholder {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(204, 204, 204, 1);
      }
    }
    .tips {
      width: 100px;
      text-align: right;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      bottom: 12px;
      right: 12px;
      .mspan {
        display: inline;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }
  }
  .btndiv {
    margin-top: 12px;
    width: 100%;
  }
}
</style>
